<template>
  <vl-column class="domainIcon">
    <svg>
      <use v-bind="{ 'xlink:href': '/svg/pbs_icons.svg#' + icon }" />
    </svg>
  </vl-column>
</template>

<script lang="ts" setup>
defineProps({
  icon: {
    type: String,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
@import '@govflanders/vl-ui-design-system-style/scss/core/setting/_colorsRaw.scss';
@import '@govflanders/vl-ui-design-system-style/scss/core/setting/_colors.scss';
a .domainIcon {
  display: block;
}

a .domainIcon svg {
  position: absolute;
  top: 15px;
  bottom: 0;
  right: 0;
  width: 70px;
  height: 70px;
  fill: $vl-action-color;
  transition: fill 0.2s;
}

a:hover .domainIcon svg {
  fill: $vl-action-hover-color;
}
</style>
